module.exports = __webpack_public_path__ + "08726b05942986bddcdc1dcd542357b6.pdf";